import React, { useState, useEffect } from 'react';
import { Slider } from 'antd';

import './components.scss';

const SliderComp = ({
  answer: choice,
  changeAnswerValue,
  options,
  onChange,
  isEditing,
}) => {
  //   debugger;
  const textvalue = options.extremeTexts
    ? options.extremeTexts
    : options.radioText
    ? options.radioText.map((item) => item.text)
    : options.map((item) => item.text);
  const [answer, setAnswer] = useState(choice);
  useEffect(() => {
    setAnswer(choice);
  }, [choice]);
  return (
    <div className="hostile" style={{ zoom: 1.25 }}>
      <Slider
        tooltipVisible={false}
        defaultValue={Number(answer)}
        value={Number(answer)}
        min={1}
        max={textvalue.length}
        onChange={(e) => {
          onChange && onChange(e);
          setAnswer(e);
          changeAnswerValue(e);
        }}
        style={{
          width: '40.625rem',
          pointerEvents: isEditing ? 'unset' : 'none',
        }}
        className="complexity-slider"
      />
      <div className="slider-enterprise-text">
        {textvalue.map((item, index) => (
          <span
            key={index}
            className={
              index + 1 === Number(answer)
                ? ' slider-text active-text'
                : 'slider-text'
            }
          >
            {item.indexOf('(') > -1 ? (
              <>
                <span>{item.split('(')[0]}</span>
                <span>({item.split('(')[1]}</span>
              </>
            ) : (
              item
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default SliderComp;
